import { TurboMount } from "turbo-mount"
import { registerComponent } from "turbo-mount/react"
import { withSentryErrorBoundary } from "~/react/components/sentry-error-boundary.tsx"
// import { initSentryReact } from "~/lib/sentry";
import MultiDomainSearch from "~/react/components/multi_domain_search.tsx"
import OperationsPanel from "~/react/components/operations-panel.tsx"
import LeadLookalikes from "~/react/components/lead_lookalikes.tsx"
import LeadLookalikesSheet from "~/react/components/lead_lookalikes_sheet.tsx"
import DomainSearch from "~/react/components/domain_search.tsx"
import DomainSidepanelEmails from "~/react/components/domain_sidepanel_emails.tsx"
import Dashboard from "~/react/components/dashboard.tsx"
import DomainSignals from "~/react/components/domain_signals.tsx"
import Discover from "~/react/components/discover.tsx"
import TamCalculator from "~/react/components/tam_calculator.tsx"
import CampaignsMetrics from "~/react/components/campaigns-metrics.tsx"
import CampaignsIssues from "~/react/components/campaigns-issues.tsx"
import EmailAccountsTable from "~/react/components/email_accounts_table.tsx"
import EmailAccountsProvisioning from "~/react/components/email-accounts-provisioning.tsx"
import DomainsTable from "~/react/components/domains_table.tsx"
import { EmailAccountsCenter } from "~/react/components/email_accounts_center"
import EmailAccountsWidgets from "~/react/components/email-accounts-widgets.tsx"
import { CampaignContent } from "~/react/components/campaign_content"
import CampaignStats from "~/react/components/campaigns/campaign-stats.tsx"

// Initialize Sentry for React error tracking
// initSentryReact();

const turboMount = new TurboMount()

// Helper function to register components with Sentry error boundary
function registerWithSentry(turboMount, name, Component) {
  registerComponent(turboMount, name, withSentryErrorBoundary(Component, name))
}

registerWithSentry(turboMount, "MultiDomainSearch", MultiDomainSearch)
registerWithSentry(turboMount, "OperationsPanel", OperationsPanel)
registerWithSentry(turboMount, "LeadLookalikes", LeadLookalikes)
registerWithSentry(turboMount, "LeadLookalikesSheet", LeadLookalikesSheet)
registerWithSentry(turboMount, "DomainSearch", DomainSearch)
registerWithSentry(turboMount, "DomainSidepanelEmails", DomainSidepanelEmails)
registerWithSentry(turboMount, "Dashboard", Dashboard)
registerWithSentry(turboMount, "DomainSignals", DomainSignals)
registerWithSentry(turboMount, "Discover", Discover)
registerWithSentry(turboMount, "TamCalculator", TamCalculator)
registerWithSentry(turboMount, "CampaignsMetrics", CampaignsMetrics)
registerWithSentry(turboMount, "CampaignsIssues", CampaignsIssues)
registerWithSentry(turboMount, "EmailAccountsTable", EmailAccountsTable)
registerWithSentry(turboMount, "EmailAccountsProvisioning", EmailAccountsProvisioning)
registerWithSentry(turboMount, "DomainsTable", DomainsTable)
registerWithSentry(turboMount, "EmailAccountsCenter", EmailAccountsCenter)
registerWithSentry(turboMount, "EmailAccountsWidgets", EmailAccountsWidgets)
registerWithSentry(turboMount, "CampaignContent", CampaignContent)
registerWithSentry(turboMount, "CampaignStats", CampaignStats)

// to register a component use:
// registerComponent(turboMount, "Hello", Hello); // where Hello is the imported the component

// to override the default controller use:
// registerComponent(turboMount, "Hello", Hello, HelloController); // where HelloController is a Stimulus controller extended from TurboMountController

// If you want to automatically register components use:
// import { registerComponents } from "turbo-mount/registerComponents/react";
// const controllers = import.meta.glob("/controllers/**/*_controller.js", { eager: true });
// const components = import.meta.glob("/components/**/*.jsx", { eager: true });
// registerComponents({ turboMount, components, controllers });
